import React from 'react';
import { SnackbarProvider } from 'notistack';
import { AppContextProvider, AuthContextProvider } from 'core/context/';
import AppRouter from 'core/routes';
import {  Button } from '@mui/material';
import ConfirmDialogProvider from 'core/context/ConfirmDialogProvider';

import './App.scss';
import Hidden from 'Hidden';

function App() {

  // add action to all snackbars
  const notistackRef = React.createRef();
  const onClickDismiss = key => () => { 
      notistackRef.current.closeSnackbar(key);
  }

  return (
    <AppContextProvider>
      <AuthContextProvider>
        <SnackbarProvider maxSnack={3} anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
          }}
          preventDuplicate
          ref={notistackRef}
          autoHideDuration={3000}
          action={(key) => (
              <Button onClick={onClickDismiss(key)} size="small" sx={{color: "#fff"}}>
                  Dismiss
              </Button>
          )}
        >
          <ConfirmDialogProvider>
            <Hidden />
            <AppRouter></AppRouter>
          </ConfirmDialogProvider>
        </SnackbarProvider>
      </AuthContextProvider>
    </AppContextProvider>
  );
}

export default React.memo(App);
